import { Box, Dialog, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: '1200px',
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  minWidth: 800,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  minheight: '470px',
  overflowY: 'auto',
  backgroundColor: '#FAFCFF',
  border: '1px solid #0000003b',
  borderRadius: '16px',
  padding: '20px',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '6px 0',
  },
}));

export const ScrollableGrid = styled(Grid)(() => ({
  maxHeight: '360px',
  overflowY: 'scroll',
  borderRadius: '6px',
  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));
